import React, { useState } from 'react';
import './AdditionalRulesSection.css';
import CustomRequirementsForm from './CustomRequirementsForm';

/**
 * AdditionalRulesSection - A collapsible accordion section for additional rule types
 * This makes it easy to add new rule types in the future without cluttering the main tabs
 */
function AdditionalRulesSection({ rules, docType, docVersion, onRuleUpdate, showToast }) {
  const [isSectionCollapsed, setIsSectionCollapsed] = useState(true); // Collapsed by default
  const [expandedSections, setExpandedSections] = useState({});

  // Configuration for additional rule types
  // To add a new rule type, just add a new entry here
  const additionalRuleTypes = [
    {
      id: 'custom_requirements',
      title: 'Custom Requirements',
      description: 'Add custom validation requirements in natural language (TODOs)',
      icon: '📝',
      component: CustomRequirementsForm,
      props: {
        requirements: rules?.custom_requirements || [],
        docType,
        docVersion,
        onRuleUpdate,
        showToast
      }
    }
    // Future rule types can be added here:
    // {
    //   id: 'custom_validation',
    //   title: 'Custom Validation',
    //   description: 'Define custom validation logic',
    //   icon: '✓',
    //   component: CustomValidationForm,
    //   props: { ... }
    // }
  ];

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  if (additionalRuleTypes.length === 0) {
    return null;
  }

  return (
    <div className="additional-rules-section">
      <div 
        className="additional-rules-main-header"
        onClick={() => setIsSectionCollapsed(!isSectionCollapsed)}
      >
        <div className="main-header-content">
          <h3>Additional Rules</h3>
          <p className="section-description">
            Additional rule types and custom configurations
          </p>
        </div>
        <span className={`main-expand-icon ${!isSectionCollapsed ? 'expanded' : ''}`}>
          ▼
        </span>
      </div>

      {!isSectionCollapsed && (
        <div className="additional-rules-list">
          {additionalRuleTypes.map((ruleType) => {
            const isExpanded = expandedSections[ruleType.id] || false;
            const RuleComponent = ruleType.component;

            return (
              <div key={ruleType.id} className="additional-rule-card">
                <div
                  className="additional-rule-header"
                  onClick={() => toggleSection(ruleType.id)}
                >
                  <div className="rule-header-content">
                    <span className="rule-icon">{ruleType.icon}</span>
                    <div className="rule-header-text">
                      <h4 className="rule-title">{ruleType.title}</h4>
                      <p className="rule-description">{ruleType.description}</p>
                    </div>
                  </div>
                  <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
                    ▼
                  </span>
                </div>

                {isExpanded && (
                  <div className="additional-rule-content">
                    <RuleComponent {...ruleType.props} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AdditionalRulesSection;

